<template>
    <div>
        <h1>Reports</h1>
        <div class="text-left">
            <select id="report-select"
                    v-capitalize-first-select
                    v-model="selected"
                    class="form-select bg-white border border-info general_border py-1 mb-2">
                <option disabled value="">Seleziona un report</option>
                <option value="1">Registrazioni, servizi e progetti </option>
                <option value="2">Crescita degli iscritti</option>
                <option value="3">Monitoraggio attività del cittadino</option>
            </select>
        </div>
        
        <!-- Messaggio quando nessun report è selezionato -->
        <div v-if="!selected" class="text-center mt-4">
            <div class="alert alert-info">
                <i class="fas fa-chart-bar me-2"></i>
                Seleziona un report dal menu a tendina per visualizzare i dati
            </div>
        </div>
        
        <!-- Loading indicator -->
        <div v-else-if="loading" class="text-center mt-4">
            <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Caricamento...</span>
            </div>
            <p class="mt-2">Caricamento del report in corso...</p>
        </div>
        
        <!-- Container del report -->
        <div v-else-if="selected && iframeUrl">
            <div class="report-iframe-container">
                <iframe
                    :src="iframeUrl"
                    frameborder="0"
                    allowtransparency
                    loading="lazy"
                    title="Reports"
                ></iframe>
            </div>
        </div>
        
        <!-- Messaggio di errore se il report non si carica -->
        <div v-else-if="selected && !iframeUrl && !loading" class="text-center mt-4">
            <div class="alert alert-warning">
                <i class="fas fa-exclamation-triangle me-2"></i>
                Impossibile caricare il report. Riprova più tardi.
            </div>
        </div>
    </div>
</template>
<script setup>
import { ref, watch } from 'vue'
import { adminService } from '@/_services'

const selected = ref('')
const iframeUrl = ref('')
const loading = ref(false)

// Mappa dashboard ID per ogni report
const dashboardMap = {
  '1': 3, // Registrazioni, servizi e progetti
  '2': 2, // Crescita degli iscritti
  '3': 4  // Monitoraggio attività del cittadino
}

// Watch per il cambio di selezione
watch(selected, async (newValue) => {
  if (!newValue) {
    iframeUrl.value = ''
    return
  }

  loading.value = true
  
  try {
    const dashboardId = dashboardMap[newValue]
    // console.log(`Report ${newValue} selected - Dashboard ID: ${dashboardId}`)
    const response = await adminService.getMetabaseEmbedUrl(dashboardId, {})
    iframeUrl.value = response.data.embedUrl
  } catch (error) {
    console.error('Errore nel caricamento del report:', error)
    iframeUrl.value = ''
  } finally {
    loading.value = false
  }
})


</script>

<style scoped>
    #report-select {
        outline: none;
    }
    .report-iframe-container iframe { 
        aspect-ratio: 16 / 9;
        width: 100%;
        border: 0;
    }
    @media screen and (max-width: 960px) {
        .report-iframe-container iframe { 
            aspect-ratio: 3 / 4;
            width: 100%;
            border: 0;
        }   
    }
</style>